'use client';

// Components
import Navbar from "@src/components/organism/shared/navbar-office";
import NavbarMobile from "@src/components/organism/shared/navbar-mobile-office";
import ListListing from "@src/components/organism/list-listing-office";

// Hooks
import { ListListingProvider } from "@src/context/list-listing-office-ctx";

const ListListingOfficeTemplate = ({ ...props }) => {
  return (
    <ListListingProvider {...props}>
      <>
        <Navbar />
        <div className="hidden dd2-xl:block">
          <NavbarMobile />
        </div>
        <ListListing />
      </>
    </ListListingProvider>
  )
}

export default ListListingOfficeTemplate
